import { render, staticRenderFns } from "./SmsShieldingSendComponent.vue?vue&type=template&id=74b15bbd&scoped=true"
import script from "./SmsShieldingSendComponent.vue?vue&type=script&lang=js"
export * from "./SmsShieldingSendComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b15bbd",
  null
  
)

export default component.exports